import { call, put, takeLatest } from 'redux-saga/effects';
import { VERIFY_MS_DYNAMICS } from './constants';
import { verifyMsDynamics } from './actions';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';
import request from 'utils/request';
import convertErrorMsg from 'utils/convertErrorMsg';
import { readToken } from 'utils/readToken';
import { INTEGRATION_PAGE } from 'common/strings';

export function* verifyMsDynamicsSaga() {
  try {
    const token = readToken();
    yield call(request, {
      method: 'post',
      endpoint: 'app/msdynamics/generatetoken',
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    });
    yield put(verifyMsDynamics.success());
    triggerNotification({
      title: INTEGRATION_PAGE.ALERTS.MSDYNAMICS_SUCCESS,
      type: NOTIFICATION.TYPE.SUCCESS,
    });
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    yield put(verifyMsDynamics.error(errorMessage));
    triggerNotification({
      title: errorMessage,
      type: NOTIFICATION.TYPE.ERROR,
    });
  }
}

export default function* msDynamicsVerify() {
  yield takeLatest(VERIFY_MS_DYNAMICS.START, verifyMsDynamicsSaga);
}
